import React from "react";
import VolunteerDetails from "./VolunteerDetails";
import "./volunteercard.css";
import { useNavigate } from "react-router-dom";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";

const VolunteerCard = ({ opportunities, carePlanId, showVolunteerInfo }) => {
  const navigate = useNavigate();
  const role = useGetRole();

  const assignedOpportunities = opportunities?.filter(
    (item) => item?.opportunityStatus === "Assigned"
  );

  const sharedOpportunities = opportunities?.filter(
    (item) => item?.opportunityStatus === "Shared"
  );

  const navigateToCareplanDetails = (carePlanId) => {
    navigate(
      `${RoleToLinkMapper(
        role
      )}request-for-volunteering-service?carePlanId=${carePlanId}&assign=true`
    );
  };

  return (
    <>
      {assignedOpportunities.length ? (
        <VolunteerDetails assignedOpportunities={assignedOpportunities} showVolunteerInfo={showVolunteerInfo} />
      ) : sharedOpportunities.length ? (
        <span>
          Shared with{" "}
          <span className="font-weight-bold">{sharedOpportunities.length}</span>{" "}
          {sharedOpportunities.length === 1 ? "volunteer" : "volunteers"}
        </span>
      ) : (
        <div
          className="assign-btn"
          onClick={() => navigateToCareplanDetails(carePlanId)}
        >
          <SmartIcon
            iconKey={"volunteerRequest"}
            color="var(--main-theme-color)"
          />
          <span>Assign</span>
        </div>
      )}
    </>
  );
};

export default VolunteerCard;
